<template>
    <v-btn depressed
            color="success"
            :disabled="isDisabled"
            :loading="isLoading"
            @click="onClick">
        {{ label }}
    </v-btn>
</template>

<script>
import API from '@/api'

import Action from '@/models/action'

export default 
{
   name: 'ActionProviderButtonComplete',

   mixins: [],

   components: 
   {

   },

   data: () => ({
    isLoading: false
   }),

   props: {
    action: {
        type: Action,
        required: true
    },
    disabled: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        default: 'Completa'
    },
    loading: {
        type: Boolean,
        default: false
    }
   },

   computed: 
   {
    isDisabled()
    {
        return this.action.isCompleted || this.disabled
    }
   },

   methods:
   {
    onClick()
    {
        let actionId = this.action.id

        this.isLoading = true

        API.action.complete(actionId)
                  .then(({ data })=>{

                    this.$emit( 'completed', data )

                  })
                  .catch((err)=>{
                    
                    this.$emit( 'error', err )

                  })
                  .finally(()=>this.isLoading=false)
    }
   },

   watch:
   {
    isLoading(value)
    {
        this.$emit('update:loading', value)
    }
   },

   mounted()
   {

   }
}
</script>